import { render, staticRenderFns } from "./GroupConnectedApps.vue?vue&type=template&id=66b82560&"
import script from "./GroupConnectedApps.vue?vue&type=script&lang=js&"
export * from "./GroupConnectedApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports